// extracted by mini-css-extract-plugin
export default {"buttons":"NewEntity_buttons__EJgqV","inputs":"NewEntity_inputs__gKmnW"};